import { type ReactElement } from "react";
import { Text } from "@/elements/text/text";
import { Formatter } from "@/model/formatter";
import { Stack } from "@/elements/stack/stack";

interface Props {
  label?: string;
  value?: number | string | Date | null;
  percentage?: boolean;
}

const formatter = new Formatter({ locale: "de" });

export function PerformanceValue({
  label,
  value,
  percentage = true,
}: Props): ReactElement {
  let content = null;

  if (typeof value === "number") {
    content = percentage ? formatter.percentage(value) : value;
  } else if (value instanceof Date) {
    content = formatter.numeralDate(value);
  } else {
    content = value;
  }

  if (!value) {
    content = "-";
  }

  return (
    <Stack size={8}>
      {label && (
        <Text
          type="micro"
          color="neutral-on-surface-lightest"
          htmlElement="span"
        >
          {label}
        </Text>
      )}
      <Text
        type="snippet-body"
        color={
          typeof value === "number" && value < 0
            ? "darker-pairings-error"
            : "inverted-pairings-default"
        }
        htmlElement="span"
      >
        {content}
      </Text>
    </Stack>
  );
}
